export enum DocumentType {
	EnrollmentForm = 'Enrollment Form',
	PaymentAuthorization = 'Payment Authorization',
	SinglePaymentAuthorization = 'Single Payment Authorization',
	StatementOfGoodsAndServices = 'Statement of Goods and Services',
	RevocableAssignment = 'Revocable Assignment',
	IrrevocableAssignment = 'Irrevocable Assignment',
	OAPEnrollment = 'OAP Enrollment',
	CancellationPolicy = 'Cancellation Policy',
	PolicyReplacement = 'Policy Replacement',
	ReplacementInformation = 'Replacement Information',
	PreneedAgreement = 'Preneed Agreement',
	CremationAuthorization = 'Cremation Authorization',
	SummaryOfCoverage = 'Summary of Coverage',
	EverplansEnrollment = 'Everplans Enrollment',
	SecondaryAddressee = 'Secondary Addressee',
	PreneedContractGuaranteed = 'Preneed Price Contract (G)',
	PreneedContractNonGuaranteed = 'Preneed Price Contract (NG)',
	GuaranteedPreneedDisclosure = 'Guaranteed Preneed Disclosure',
	DeferredAnnuityDisclosure = 'Deferred Annuity Disclosure',
	DisclosureStatement = 'Disclosure Statement',
	AuthorizedAgentDisclosure = 'Authorized Agent Disclosure',
	MergedDocument = 'Merged Document',
	EverplansMergedDocument = 'Everplans Merged Document',
}
